<template>
  <header
    :class="[
      'header-area bg-white mb-4 rounded-bottom-15',
      { sticky: isSticky },
    ]"
  >
    <div class="row align-items-center header-inner-area">
      <div class="col-6 col-lg-5">
        <div class="left-header-content">
          <ul
            class="d-flex align-items-center ps-0 mb-0 list-unstyled justify-content-start"
          >
            <li class="logo">
              <RouterLink to="/dashboard" class="d-block d-md-none text-decoration-none">
                <img class="logo-black" src="@/assets/images/logo-icon.png" alt="logo-icon" style="max-width:25px" />
                <img class="logo-white" src="@/assets/images/logo-icon.png" alt="logo-icon" style="max-width:25px" />
              </RouterLink>
            </li>
            <li class="burger-menu d-none d-lg-block">
              <button
                class="header-burger-menu bg-transparent p-0 border-0"
                :class="[
                  'header-burger-menu bg-transparent p-0 border-0',
                  { active: stateStoreInstance.open },
                ]"
                @click="stateStoreInstance.onChange"
              >
                <span class="material-symbols-outlined">menu</span>
              </button>
            </li>
            <!-- <li>
              <SearchFrom />
            </li> -->
            <li>
              <!-- Web Apps - Hidden -->
              <!-- <WebApps /> -->
            </li>
          </ul>
        </div>
      </div>

      <div class="col-6 col-lg-7">
        <div class="right-header-content mt-2 mt-sm-0">
          <ul
            class="d-flex align-items-center justify-content-end ps-0 mb-0 list-unstyled"
          >
            <li class="header-right-item">
              <DarkSwtichBtn />
            </li>
            <!-- Language Dropdown Li - Hidden -->
            <!-- <li class="header-right-item">
              <LanguageMenu />
            </li> -->
            <!-- Fullscreen Button Li - Hidden -->
            <!-- <li class="header-right-item">
              <ToggleFullscreenBtn />
            </li> -->
            <!-- Notifications Dropdown Li - Hidden -->
            <!-- <li class="header-right-item">
              <NotificationsLists />
            </li> -->
            <li class="header-right-item">
              <AdminProfile v-if="authStore.isLoggedIn.value" />
              <AuthButtons v-else />
            </li>
            <!--<li class="header-right-item">
              <SettingsBtn />
            </li>-->
            <!-- Mobile burger menu positioned at the extreme right -->
            <li class="header-right-item mobile-burger-menu burger-menu d-lg-none">
              <button
                class="header-burger-menu bg-transparent p-0 border-0"
                :class="[
                  'header-burger-menu bg-transparent p-0 border-0',
                  { active: stateStoreInstance.open },
                ]"
                @click="stateStoreInstance.onChange"
              >
                <span class="material-symbols-outlined">menu</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Navbar />
  </header>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import stateStore from "@/utils/store";

import SearchFrom from "./SearchFrom.vue";
import WebApps from "./WebApps.vue";
import DarkSwtichBtn from "./DarkSwtichBtn.vue";
import LanguageMenu from "./LanguageMenu.vue";
import ToggleFullscreenBtn from "./ToggleFullscreenBtn.vue";
import NotificationsLists from "./NotificationsLists.vue";
import AdminProfile from "./AdminProfile.vue";
import AuthButtons from "./AuthButtons.vue"; // New import
import SettingsBtn from "./SettingsBtn.vue";
import Navbar from "./Navbar.vue";

import { authStore } from '@/stores/auth'; // New import

const stateStoreInstance = stateStore;
const isSticky = ref(false);

onMounted(() => {
  window.addEventListener("scroll", () => {
    let scrollPos = window.scrollY;
    isSticky.value = scrollPos >= 100;
  });
});
</script>

<style scoped>
.mobile-burger-menu {
  margin-right: 16px !important;
}

@media (max-width: 991.98px) {
  .logo {
    display: block !important;
  }
  .logo img {
    height: 25px !important;
    margin-left: 16px !important;
  }
  .logo-white {
    display: none !important;
  }
}

:global(.dark-theme) .logo-black {
  display: none !important;
}

:global(.dark-theme) .logo-white {
  display: block !important;
}

</style>